"use client";

// import { Provider } from "react-redux";
// import { store } from "./store/store";
import { TaskDialogProvider } from "../context/task-dialog-context";
import { TooltipProvider } from "@/app/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useState } from "react";
import { AuthProvider } from "./contexts/AuthContext";
import { GoogleMapsProvider } from "./providers/GoogleMapsProvider";

function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // With SSR, we usually want to set some default staleTime
        // above 0 to avoid refetching immediately on the client
        staleTime: 60 * 1000, // 1 minute default
        gcTime: 5 * 60 * 1000, // 5 minutes garbage collection time (was cacheTime in v4)
        retry: 1,
        refetchOnWindowFocus: false, // Can be changed based on your needs
      },
    },
  });
}

let browserQueryClient: QueryClient | undefined = undefined;

function getQueryClient() {
  if (typeof window === "undefined") {
    // Server: always make a new query client
    return makeQueryClient();
  } else {
    // Browser: make a new query client if we don't already have one
    if (!browserQueryClient) browserQueryClient = makeQueryClient();
    return browserQueryClient;
  }
}

export function Providers({ children }: { children: React.ReactNode }) {
  // NOTE: Avoid useState when initializing the query client if you don't
  // have a suspense boundary between this and the code that may suspend because
  // React will throw away the client on the initial render if it suspends and
  // there is no boundary
  const [queryClient] = useState(() => getQueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        {/* <Provider store={store}> */}
          <GoogleMapsProvider>
            <TaskDialogProvider>
              <TooltipProvider>{children}</TooltipProvider>
            </TaskDialogProvider>
          </GoogleMapsProvider>
        {/* </Provider> */}
      </AuthProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}